import { render, staticRenderFns } from "./StayTuned.vue?vue&type=template&id=767b0478&scoped=true&"
import script from "./StayTuned.vue?vue&type=script&lang=js&"
export * from "./StayTuned.vue?vue&type=script&lang=js&"
import style0 from "./StayTuned.vue?vue&type=style&index=0&id=767b0478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b0478",
  null
  
)

export default component.exports